export default "__VITE_ASSET__BGQMkRZ6__"